<template>
  <div
    ref="cell"
    class="grid-view__cell active"
    :class="{ editing }"
    @contextmenu="stopContextIfEditing($event)"
  >
    <div
      v-if="!editing"
      class="grid-field-date job-schedule-grid-value"
      :title="`${displayDate}   ${displayTime}`"
    >
      <div class="grid-field-date__date">{{ displayDate }}</div>
      <div class="grid-field-date__time">{{ displayTime }}</div>
    </div>
    <JobScheduleEditor
      v-else
      ref="editor"
      v-model="copy"
      :timezone="field.timezone"
      compact
      @blur="saveIfValid"
      @prevent-unselect="preventNextUnselect = true"
    />
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import gridFieldInput from '@baserow/modules/database/mixins/gridFieldInput'
import JobScheduleEditor from '@peninsula/components/JobScheduleEditor'
import { formatScheduleDate, formatScheduleTime } from '@peninsula/jobSchedule'

export default {
  name: 'JobScheduleGridField',
  components: { JobScheduleEditor },
  mixins: [gridField, gridFieldInput],
  data() {
    return { preventNextUnselect: false }
  },
  computed: {
    displayDate() {
      return this.value
        ? formatScheduleDate(this.value, this.field.timezone)
        : ''
    },
    displayTime() {
      return this.value
        ? formatScheduleTime(this.value, this.field.timezone)
        : ''
    },
  },
  methods: {
    afterEdit() {
      this.$nextTick(() => this.$refs.editor.focus())
    },
    canUnselectByClickingOutside(event) {
      if (this.editing && this.preventNextUnselect) {
        this.preventNextUnselect = false
        return false
      }

      return (
        !this.editing || !this.$refs.editor?.containsContextTarget(event.target)
      )
    },
    saveIfValid() {
      if (this.editing && this.isValid()) this.save()
    },
  },
}
</script>

<style scoped>
.job-schedule-grid-value {
  gap: 8px;
}

.job-schedule-grid-value .grid-field-date__date {
  flex: 0 0 auto;
  width: auto;
  overflow: visible;
}

.job-schedule-grid-value .grid-field-date__time {
  flex: 1 1 auto;
  width: auto;
  max-width: none;
  min-width: 0;
  text-align: right;
}
</style>
